export default {"src":"/_next/static/media/03_Gift_PT.7d65df56.gif","height":175,"width":439};